import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class WorkProgramConfig  {
    _originalTypeClassName = "zERP.BO.WorkProgramConfig";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
WorkProgramConfig.translate = translateService;
}
this.Id = null;
this.DayHours = null;
this.DayFrom1 = null;
this.DayTo1 = null;
this.DayFrom2 = null;
this.DayTo2 = null;
this.Name = null;
this.Description = null;
this.Code = null;
this.Type = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
DayHours:any;
DayFrom1:any;
DayTo1:any;
DayFrom2:any;
DayTo2:any;
Name:any;
Description:any;
Code:any;
Type:any;
Break:any;
static setBreak = ($this, value) => {
var oldValue = $this.Break;
$this.Break = value;
if (value != null) {
}
}

static GetClassName(): any{return "WorkProgramConfig";
}
static ParseGreekBoolean(val: any): any{if ((CLMS.Framework.String.IsNullOrEmpty((val ?? '').trim()))) {return false;}
let c = val?.trim()?.toUpperCase();
if ((c?.indexOf("ΝΑ") === 0)) {return true;}
if ((c?.indexOf("NA") === 0)) {return true;}
if ((c == "1")) {return true;}
if ((Joove.Common.stringContains(c, "TRUE"))) {return true;}
return false;
}
static ParseTimeField(val: any): any{if ((CLMS.Framework.String.IsNullOrEmpty((val ?? '').trim()))) {return ;}
let s = val?.trim();
if ((!(Joove.Common.stringContains(s, ":")))) {return ;}
try {let parsed = CLMS.Framework.DateTime.ParseExact(s, Joove.GlobalizationManager.GetCurrentLocaleManager().SortName, "H:m").toDate();let year = moment(parsed).year();let march31 = moment([year, (3) - 1, 31]).toDate();let marchDifference = moment(march31).day();let dstStart = (moment(march31).add(Joove.Common.safeNumber(0) - Joove.Common.safeNumber(marchDifference), "d")).toDate();let oct31 = moment([year, (10) - 1, 31]).toDate();let octDifference = moment(oct31).day();let dstEnd = (moment(oct31).add(Joove.Common.safeNumber(0) - Joove.Common.safeNumber(octDifference), "d")).toDate();if ((CLMS.Framework.Number.GreaterThanOrEqual(() => CLMS.Framework.DateTime.Compare(parsed, dstStart), () => 0) && CLMS.Framework.Number.LessThan(() => CLMS.Framework.DateTime.Compare(parsed, dstEnd), () => 0))) {return (moment(parsed).add(-3, "h")).toDate();}else {return (moment(parsed).add(-2, "h")).toDate();}}
catch (x) {return ;}
}
static ParseWorkProgramType(el: any): any{if ((CLMS.Framework.String.IsNullOrEmpty((el ?? '').trim()))) {return Domain.WorkProgramType.NoWork;}
let val = el?.trim()?.toUpperCase();
if ((Joove.Common.stringContains(val, "ΤΗΛΕ"))) {return Domain.WorkProgramType.RemoteWork;}
if ((Joove.Common.stringContains(val, "ΕΡΓΑΣΙΑ"))) {return Domain.WorkProgramType.Work;}
if ((Joove.Common.stringContains(val, "ΥΠΕΡΩΡ"))) {return Domain.WorkProgramType.OverHours;}
if ((Joove.Common.stringContains(val, "ΑΝΑΠ"))) {return Domain.WorkProgramType.Rest;}
return Domain.WorkProgramType.NoWork;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}